// extracted by mini-css-extract-plugin
export default {"list":"_3sA6L","icon":"_3pTN1"};